<template>
    <div>
        <!-- ROOM SERVICES -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6>
                    <img :src="getImageUrl('dettagli/servizi 2.jpeg')" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <v-icon size="70" class="success--text text--lighten-2">fas fa-concierge-bell</v-icon>
                        </v-card-title>
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("services.room_services")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("services.room_services_details")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>

        <!-- RENT BIKE -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <v-icon size="70" class="success--text text--lighten-2">fas fa-bicycle</v-icon>
                        </v-card-title>
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("services.bike_rent")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("services.bike_rent_details")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2>
                    <img :src="getImageUrl('dettagli/servizi.jpeg')" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section>

        <!-- LUNCH BOX -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md1 order-lg1>
                    <img :src="getImageUrl('cibo/colazione_1.jpeg')" alt="" class="my-fit" style="max-height: 506px">
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md2 order-lg2>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <v-icon size="70" class="success--text text--lighten-2">fas fa-utensils</v-icon>
                        </v-card-title>
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("services.lunch_box")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("services.lunch_box_details")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>
    </div>
</template>

<script>
export default {
    methods: {
      getImageUrl: function(image){
        return require(`../assets/img/${image}`);
      }
    }
}
</script>

<style scoped>
    .sub-intro{
        font-size: large;
        font-weight: 400;
    }

    .my-headline{
        font-size: xx-large;
        font-weight: 300;
        font-style: italic;
    }

    .mybg{
        background-color: var(--v-primary-base);
    }

    .my-fit{
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 500px;
    }
</style>